import { useState } from "react";
import { errorText } from "@/lib/api";
import { Panel, Label, Field, Select, Button, Notice } from "@/webapp/fleet-owners/ui";

const opt = (o) => (Array.isArray(o) ? o : [o, o.replace(/_/g, " ")]);

export default function RecordForm({ fields, initial, onSave, onCancel, prefix }) {
  const [form, setForm] = useState(initial);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true); setErr("");
    try { await onSave(form); } catch (e) { setErr(errorText(e)); }
    setBusy(false);
  };
  return (
    <Panel className="fo-rise mb-6 p-6" testid={`${prefix}-form`}>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {fields.map((f) => (
          <div key={f.k}>
            <Label>{f.label}</Label>
            {f.options
              ? <Select data-testid={`${prefix}-field-${f.k}`} value={form[f.k] ?? ""} onChange={(e) => setForm({ ...form, [f.k]: e.target.value })}>{f.options.map((o) => { const [v, l] = opt(o); return <option key={v} value={v}>{l}</option>; })}</Select>
              : <Field data-testid={`${prefix}-field-${f.k}`} type={f.type || "text"} value={form[f.k] ?? ""} placeholder={f.placeholder} onChange={(e) => setForm({ ...form, [f.k]: e.target.value })} />}
          </div>
        ))}
      </div>
      {err && <div className="mt-4"><Notice testid={`${prefix}-form-error`}>{err}</Notice></div>}
      <div className="mt-5 flex gap-2">
        <Button variant="primary" testid={`${prefix}-form-save`} onClick={save} disabled={busy}>{busy ? "Saving…" : "Save"}</Button>
        <Button variant="ghost" testid={`${prefix}-form-cancel`} onClick={onCancel}>Cancel</Button>
      </div>
    </Panel>
  );
}
